<template>
  <div id="publishing-editorial-board-detail">
    <ipub-model width="750px"
                :visable="isVisable"
                :showHeader="false"
                :showFooter="false"
                @cancel="cancel">
      <div class="flex editorial-board-detail-avatar mar-b-20">
        <div class="editorial-board-detail-avatar-img">
          <img :src="`${domain}/${inputData.icon||'imageFile/icon.svg'}`"
               alt="">
        </div>
        <div class=" mar-l-20 ipub-p2">
          <div class="ipub-p1 mar-b-20">Dr. {{inputData.firstName}} {{inputData.lastName}}</div>
          <div class="flex mar-b-10">
            <div class="fw-bd"
                 style="width:160px">Email</div>
            <div class="mar-l-10"
                 style="width:calc(100% - 160px)">{{inputData.email}}</div>
          </div>
          <div class="flex mar-b-10">
            <div class="fw-bd"
                 style="width:160px">
              Country / Territory
            </div>
            <div class="mar-l-10"
                 style="width:calc(100% - 160px)">{{country[inputData.countryCode]}}</div>
          </div>
          <div class="flex mar-b-10">
            <div class="fw-bd"
                 style="width:160px">City</div>
            <div class="mar-l-10"
                 style="width:calc(100% - 160px)">{{inputData.city||'--'}}</div>
          </div>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">ORCID</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">{{inputData.orcid || '--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">H-index</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">{{inputData.hindex || '--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">H-index URL</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">
          <a v-if="inputData.hindexUrl"
             :href="inputData.hindexUrl"
             class="link-color">{{inputData.hindexUrl}}</a>
          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">Affiliations</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">
          <template v-if="inputData.affiliation">{{inputData.affiliation.split(';')?inputData.affiliation.split(';').join('; '):'--'}}</template>
          <template v-else>--</template>
        </div>
      </div>
      <!-- <div class="flex mar-b-10 ipub-p2">
        <div class="ipub-p2"
             style="width:160px">Affiliation Address</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">{{inputData.affiliationAddress || '--'}}</div>
      </div> -->
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">Website</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">
          <a v-if="inputData.website"
             :href="inputData.website"
             class="link-color">{{inputData.website}}</a>
          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">Reviewed Journal</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">{{inputData.reviewJournal?inputData.reviewJournal.split(';').join('; '):'--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2"
           style="al">
        <div class="fw-bd"
             style="width:160px">CV</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">
          <ipub-label v-if="inputData.rcv"
                      class="ipub-upload--label__item flex link-color ipub-c-p"
                      @click="download(`${domain}/${inputData.rcv}`, inputData.rcvName)">
            {{inputData.rcvName}}
            <ipub-icon class="mar-l-10"
                       style="font-size:16px"
                       type="iconDownload1" />
          </ipub-label>
          <!-- <div class="ipub-upload--label__item flex"
               v-for="(item, index) in fileList"
               :key="item[_name]+'upload'+index">
            {{item[_name]}}
            <ipub-icon class="mar-l-10 ipub-c-p"
                       @click="download(item[_path], item[_name], domain)"
                       type="iconDownload1" />
            <div v-if="!disabled"
                 class="flex ipub-upload--label__item__delete ipub-c-p">
              <ipub-icon @click="handleDelete(index)"
                         type="iconDelete" />
            </div>
          </div> -->

          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">Research Keywords</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">
          <template v-if="inputData.keyword&&inputData.keyword.length">
            {{inputData.keyword.includes(';')?inputData.keyword.split(';').join('; '):inputData.keyword}}
            <!-- <ipub-label :style="{margin: '0 16px 16px 0'}"
                        v-for="(item, index) in inputData.keyword.split(',')"
                        :key="'inputData.keywords'+index"
                        size="common"
                        circle
                        hover>{{item}}</ipub-label> -->
          </template>
          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">Journals</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">
          <template v-for="(item, index) in inputData.journalList">
            {{item.name}}<template v-if="index!==inputData.journalList.length-1">; </template>
          </template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:160px">Review Frequency</div>
        <div class="mar-l-10"
             style="width:calc(100% - 170px)">{{reviewFrequency[inputData.frequencyCode] || '--'}}</div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
      country: 'getCountry',
      reviewFrequency: 'getReviewFrequency',
      degree: 'getDegree',
    })
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    download (url, name) {
      help.download(url, name)
    }
  }
}
</script>

<style lang="scss" scoped>
#publishing-editorial-board-detail {
  .editorial-board-detail {
    &-avatar {
      &-img {
        border-radius: 4px;
        height: 134px;
        width: 108px;
        font-size: 170px;
        color: $line_color;
        background: $font_color;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        > img {
          height: 100%;
        }
      }
    }
  }
}
</style>
